import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSessionContext } from '@/features/auth';

interface ProtectedRouteProps {
	children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const location = useLocation();
	const { isAuthenticated } = useSessionContext();

	if (!isAuthenticated) {
		return (
			<Navigate
				to='/login'
				state={{ from: location }}
				replace
			/>
		);
	}

	if (children) {
		return <>{children}</>;
	}

	return <Outlet />;
};

export default ProtectedRoute;
